import { render, staticRenderFns } from "./restart-wizard-button.vue?vue&type=template&id=14a9ea44"
import script from "./restart-wizard-button.vue?vue&type=script&lang=js"
export * from "./restart-wizard-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports